import React from 'react';
import styled from 'styled-components';
import { HelpIcon, HelpIconContainer } from 'src/components/widgets/helpIconContainer';

// IL SEGNO DICE «C'È UNA RAGIONE», non «c'è un errore»: è lo stesso punto informativo che
// FormControl mette accanto alle sue etichette — quello dello storybook Zakeke — così chi passa
// dal Composer all'inspector riconosce il segno prima di leggerlo.
//
// NON È UN PULSANTE: non porta da nessuna parte, e il testo lo si legge passandoci sopra.
const Marker = styled(HelpIconContainer)`
    position: static;
    cursor: pointer;
    border-radius: 50%;
    background: rgba(244, 81, 30, 0.08);

    &:hover {
        background: rgba(244, 81, 30, 0.14);
    }
`;

// UN CAPOVERSO PER PENSIERO. Tre frasi di fila diventano un muro che si salta: separate, si leggono
// nell'ordine in cui servono — che cosa succede, perché, e se tocca a me rimediare.
const Paragraph = styled.p`
    margin: 0;

    & + & {
        margin-top: 8px;
    }
`;

/**
 * La ragione per cui un gruppo di proprietà non si comporta come ci si aspetta, a portata di
 * passaggio. Il testo lo scrive chi la conosce: qui non si sa niente del perché.
 */
export const PropertiesPanelHint = ({ text }: { text: string | string[] }) => {
    const paragraphs = Array.isArray(text) ? text : [text];

    return (
        <Marker
            tooltip={paragraphs.map((paragraph, index) => (
                <Paragraph key={index}>{paragraph}</Paragraph>
            ))}
            interactive={false}
            position='bottom'
            maxWidth={340}
            role='img'
            aria-label={paragraphs.join(' ')}
        >
            <HelpIcon />
        </Marker>
    );
};
